import React, {useState, useEffect} from 'react'
import Icons from '../Icons'
import css from './Tooltip.module.scss'

const Tooltip = ({text}) => {
	const [isOpen, setOpen] = useState(false)
	const ref = React.useRef(null)

	const onDocumentMouseDown = (e) => {
		if (!ref.current.contains(e.target)) {
			listeners(false)
			setOpen(false)
		}

		console.log(e.target)
	}

	const listeners = (active = true) => {
		if (active) {
			document.addEventListener('mousedown', onDocumentMouseDown, true)
			document.addEventListener('click', onDocumentMouseDown)
		} else{
			document.removeEventListener('mousedown', onDocumentMouseDown, true)
			document.removeEventListener('click', onDocumentMouseDown)
		}
	}

	const toogle = () => {
		listeners(!isOpen)
		setOpen(!isOpen)
	}

	useEffect(() => {
		return () => {
			listeners(false)
		}
	},[])

	return (
		<div className={css.tooltip + ' ' + (isOpen ? css.active : '')} ref={ref}>
			<div className={css.icon} onClick={toogle}>
				<Icons name="question"/>
			</div>
			{isOpen
				? <div className={css.body}>
					{text}
				</div>
				: null
			}
			<div className={css.body}>
				{text}
			</div>
		</div>
	)
}

export default Tooltip
